'use client';

/**
 * OrganizationTabs
 *
 * Tab navigation component for organization detail page.
 * Uses URL query parameters to track active tab.
 */

import { Tabs, TabsList, TabsTrigger } from '@cortex/ui';
import { useNavigate } from '@tanstack/react-router';
import { FileText, Key, Link2, Settings, Users } from 'lucide-react';

interface OrganizationTabsProps {
  organizationSlug: string;
  activeTab: string;
}

export function OrganizationTabs({
  organizationSlug,
  activeTab,
}: OrganizationTabsProps) {
  const navigate = useNavigate();

  const handleTabChange = (tabId: string) => {
    navigate({
      to: '/admin/organizations/$slug',
      params: { slug: organizationSlug },
      search: { tab: tabId },
    });
  };

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList variant="underline">
        <TabsTrigger value="details" variant="underline" icon={Settings}>
          Details
        </TabsTrigger>
        <TabsTrigger value="connections" variant="underline" icon={Link2}>
          Connections
        </TabsTrigger>
        <TabsTrigger value="users" variant="underline" icon={Users}>
          Users
        </TabsTrigger>
        <TabsTrigger value="projects" variant="underline" icon={FileText}>
          Projects
        </TabsTrigger>
        <TabsTrigger value="environment" variant="underline" icon={Key}>
          Environment
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
